import angularInview from "angular-inview";
import "angular-drag-and-drop-lists";
import core from "@gtmhub/core/module";
import attachments from "@gtmhub/attachments/module";
import { ArchivedTasksCtrl } from "./controllers/archived";
import { TaskFormCtrl } from "./controllers/form";
import { TaskFormComponent } from "./components/task-form.component";
import { TaskFilterCtrl } from "./controllers/task-filter";
import { TaskRowCtrl } from "./controllers/task-row";
import { TasksCtrl } from "./controllers/tasks";
import { TaskService } from "./services/taskService";
import { TaskStatusComponent } from "./components/task-status.component";

export default angular
  .module("tasks", [core, attachments, angularInview, "dndLists"])
  .controller("ArchivedTasksCtrl", ArchivedTasksCtrl)
  .component("taskForm", TaskFormComponent)
  .component("taskStatus", TaskStatusComponent)
  .controller("TasksCtrl", TasksCtrl)
  .controller("TaskFilterCtrl", TaskFilterCtrl)
  .controller("TaskFormCtrl", TaskFormCtrl)
  .controller("TaskRowCtrl", TaskRowCtrl)
  .service("TaskService", TaskService).name;
